export const SET_PAGELOADING = 'SET_PAGELOADING';
export const SET_ALL_ORDER_IDS = 'SET_ALL_ORDER_IDS';

export const GET_ORDERS_BUNDLE_DETAILS = 'GET_ORDERS_BUNDLE_DETAILS';

export const CLEAR_DETAILS = 'CLEAR_DETAILS';
export const SET_STEP_CONFIG = 'SET_STEP_CONFIG'
